/* eslint-disable consistent-return */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/prop-types */

import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import { useIntl } from 'react-intl';
import AppRadioInput from '../../shared/components/app-radio-input/AppRadioInput';
import AppAsyncSelect from '../../shared/components/app-async-select/AppAsyncSelect';
import AppDatePicker from '../../shared/components/app-date-picker/AppDatePicker';
import AppSelect from '../../shared/components/app-select/AppSelect';
import AppButton from '../../shared/components/app-button/AppButton';
import { debounce } from '../../api/apiUtils';
import { getAirportsApi } from '../../api/flightApi';
import AppNumberInput from '../../shared/components/app-number-input/AppNumberInput';
import { formatDate, getNewDate } from '../../shared/helper-utils/appUtils';
import { API_DATE_FORMAT, TODAY_DATE } from '../../shared/constants/Constants';
import AppAlert from '../../shared/components/app-alert/AppAlert';
import { groupBookingRequest } from '../../api/profileApi';
import AppLoading from '../../shared/components/app-loading/AppLoading';
import AppTextInput from '../../shared/components/app-text-input/AppTextInput';
import AppLink from '../../shared/components/app-link/AppLink';

// import { useAppContext } from '../../saas/AppConfigWrapper';

const DEBOUNCE_DELAY = 500;

const PREF_CLASS_OPTIONS = [
  { label: 'All', value: 'All' },
  { label: 'First Class', value: 'First Class' },
  { label: 'Premium Economy', value: 'Premium Economy' },
  { label: 'Economy', value: 'Economy' },
  { label: 'Business', value: 'Business' },
];

const PREF_AIRLINE_OPTIONS = [
  { label: 'All', value: 'All' },
  { label: 'BSP Carriers Only', value: 'GDS' },
  { label: 'Low Cost Only', value: 'LCC' },
  { label: 'Go airways(G8)', value: 'G8' },
  { label: 'Spicejet(SG)', value: 'SG' },
  { label: 'Jet Airways(9W)', value: '9W' },
  { label: 'Paramount(I7)', value: 'I7' },
  { label: 'Kingfisher(IT)', value: 'IT' },
  { label: 'Jetlite(S2)', value: 'S2' },
  { label: 'Indian Airlines(IC)', value: 'IC' },
  { label: 'Air India(AI)', value: 'AI' },
  { label: 'Indigo(6E)', value: '6E' },
];

const GROUP_TYPE_OPTIONS = [
  { label: '--Select--', value: '' },
  { label: 'Sports', value: 'sports' },
  { label: 'Wedding', value: 'wedding' },
  { label: 'Pilgrimage', value: 'pilgrimage' },
  { label: 'Mice', value: 'mice' },
  { label: 'Other', value: 'Other' },
];

// const JOURNEY_TYPE = [
//   { label: 'Domestic Travel', value: 'Domestic Travel' },
//   { label: 'International Travel', value: 'International Travel' },
// ];

export function AirportOption(props) {
  return (
    <div
      onClick={() => props.selectOption(props.data)}
      className={`${props.isFocused ? 'airport-focused' : ''} airport-option`}
      key={props.value}
    >
      <div className="d-flex justify-content-between p-1">
        <div className="airport-city-details">
          <div className="fs-14 d-flex align-items-center">
            <span className="airport-option_country-code">
              {props.data.AirportCode}
            </span>
            <span className="black-color">
              {props.data.AirportLocation.split(',')[0]}
            </span>
          </div>
          <div className="airport-option_airport-name">
            {props.data.AirportName}
          </div>
        </div>
        <div className="d-flex align-items-center justify-content-end fs-12 airport-country-details gap-1">
          <span className="black-color">{props.data.Country}</span>
          <img
            src={`https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/${props.data.CountryCode.toLowerCase()}.svg`}
          />
        </div>
      </div>
    </div>
  );
}

function GroupBookingRequest({ agent }) {
  const intl = useIntl();
  // const { appConfig } = useAppContext();
  const formattedMessage = (message) => {
    return intl.formatMessage({ id: message });
  };

  const [journeyType, setJourneyType] = useState('OneWay');
  const [origin, setOrigin] = useState('');
  const [destination, setDestination] = useState('');
  const originAirportRef = useRef(null);
  const destinationAirportRef = useRef(null);
  const [travelType, setTravelType] = useState('Domestic Travel');
  const [prefAirline, setPrefAirline] = useState('All');
  const [groupTypeOption, setGroupTypeOption] = useState('');
  const [prefClass, setPrefClass] = useState('All');
  const [remarks, setRemarks] = useState('');
  const [fromDate, setFromDate] = useState(getNewDate(TODAY_DATE));
  const [fromDateFlexible, setFromDateFlexible] = useState('0');
  const [toDate, setToDate] = useState('');
  const [toDateFlexible, setToDateFlexible] = useState('0');
  const [numberOfAdult, setNumberOfAdult] = useState('');
  const [numberOfChild, setNumberOfChild] = useState('');
  const [numberOfInfant, setNumberOfInfant] = useState('');
  const [alert, setAlert] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const [multiCitySearch, setMulticitySearch] = useState([
    {
      origin: '',
      destination: '',
      onwarddate: getNewDate(TODAY_DATE),
      onwarddateFlexible: '0',
      selectedOrigin: '',
      selectedDestination: '',
    },
  ]);

  const loadAirportSuggestions = debounce(async (query, callback) => {
    let airports = [];
    if (query.length >= 3) {
      const response = await getAirportsApi(query);
      airports = response.map((airportNode) => ({
        label: `${airportNode.AirportCode} - ${airportNode.AirportLocation}`,
        value: airportNode.AirportCode,
        ...airportNode,
      }));
    }
    callback(airports);
  }, DEBOUNCE_DELAY);

  const handleAirportSelect = (airport, name) => {
    if (name === 'origin') {
      originAirportRef.current = airport;
      let originAirportCode = '';
      if (airport !== null) {
        originAirportCode = airport.value;
      }
      setOrigin(originAirportCode);
    } else {
      destinationAirportRef.current = airport;
      let destinationAirportCode = '';
      if (airport !== null) {
        destinationAirportCode = airport.value;
      }
      setDestination(destinationAirportCode);
    }
  };

  const onRemoveMultiCityRow = (index) => {
    const multiCity = [...multiCitySearch];
    multiCity.splice(index, 1);
    setMulticitySearch(multiCity);
  };

  const onAddMultiCityRow = () => {
    const multiCity = [...multiCitySearch];
    const obj = {
      origin: '',
      destination: '',
      onwarddate: getNewDate(TODAY_DATE),
    };
    multiCity.push(obj);
    setMulticitySearch(multiCity);
  };

  const handleMultiCityChange = (data, name, index) => {
    const multiCity = [...multiCitySearch];
    if (name === 'origin') {
      multiCity[index].origin = data.value;
      multiCity[index].selectedOrigin = data;
    } else if (name === 'destination') {
      multiCity[index].destination = data.value;
      multiCity[index].selectedDestination = data;
    } else if (name === 'onwarddate') {
      multiCity[index].onwarddate = getNewDate(data);
    } else if (name === 'onwarddateFlexible') {
      multiCity[index].onwarddateFlexible = data;
    }

    setMulticitySearch(multiCity);
  };

  const handleGroupBookingRequest = async () => {
    if (journeyType !== 'MultiCity') {
      if (
        origin === '' ||
        destination === '' ||
        numberOfAdult === '' ||
        numberOfChild === '' ||
        numberOfInfant === '' ||
        groupTypeOption === '' ||
        remarks === ''
      ) {
        setAlert({
          variant: 'error',
          title: 'Group Booking Request',
          description: 'Please enter required details',
        });
        return false;
      }
      if (origin === destination) {
        setAlert({
          variant: 'error',
          title: 'Group Booking Request',
          description: 'Origin and Destination cannot be same',
        });
        return false;
      }
      if (journeyType === 'RoundTrip') {
        if (toDate === '' || toDate === undefined) {
          setAlert({
            variant: 'error',
            title: 'Group Booking Request',
            description: 'Select Return Date',
          });
          return false;
        }
      }
    }
    setIsLoading(true);
    let htmlContent = `<table border='1' cellpadding='5' cellspacing='0' style='width:50%;font-size:12px;line-height: 23px;border:1px solid #000'><tr><td style='width:25%'>Agent Company</td><td style='width:25%'><b>${agent.Company} (${agent.AgentId})</b></td></tr><tr><td style='width:25%'>Contact Number</td><td style='width:25%'><b>${agent.ContactNumber},${agent.MobileNumber}</b></td></tr><tr><td style='width:25%'>Email</td><td style='width:25%'><b>${agent.ContactEmail}</b></td></tr><tr><td colspan="2"><hr style='border:0px'></td></tr><tr><td style='width:25%'>Journey</td><td style='width:25%'>${travelType}</td></tr><tr><td style='width:25%'>Journey Type</td><td style='width:25%'>${journeyType}</td></tr>`;
    if (journeyType !== 'MultiCity') {
      htmlContent += `<tr><td style='width:25%'>Origin</td><td style='width:25%'>${origin}</td></tr><tr><td style='width:25%'>Destination</td><td style='width:25%'>${destination}</td></tr><tr><td style='width:25%'>Onward Journey (yy-mm-dd)</td><td style='width:25%'>${formatDate(
        fromDate,
        API_DATE_FORMAT,
      )}( Flexible by ${fromDateFlexible} Days)</td></tr><tr><td style='width:25%'>Return Journey (yy-mm-dd)</td><td style='width:25%'>${
        journeyType === 'RoundTrip' ? formatDate(toDate, API_DATE_FORMAT) : 'NA'
      }( Flexible by ${toDateFlexible} Days)</td></tr><tr><td style='width:25%'>No of Adults</td><td style='width:25%'>${numberOfAdult}</td></tr><tr><td style='width:25%'>No of Child</td><td style='width:25%'>${numberOfChild}</td></tr><tr><td style='width:25%'>No of Infant</td><td style='width:25%'>${numberOfInfant}</td></tr><tr><td style='width:25%'>Pref Class</td><td style='width:25%'>${prefClass}</td></tr><tr><td style='width:25%'>Pref Airline</td><td style='width:25%'>${prefAirline}</td></tr><tr><td style='width:25%'>Group Type</td><td style='width:25%'>${groupTypeOption}</td></tr><tr><td style='width:25%'>Remarks</td><td style='width:25%'>${remarks}</td></tr></table>`;
    } else {
      multiCitySearch.forEach((city, index) => {
        htmlContent += `<tr><td style='width:25%'>City No</td><td style='width:25%'>${
          index + 1
        }</td></tr><tr><td style='width:25%'>Origin</td><td style='width:25%'>${
          city.origin
        }</td></tr><tr><td style='width:25%'>Destination</td><td style='width:25%'>${
          city.destination
        }</td></tr><tr><td style='width:25%'>Onward Journey (yy-mm-dd)</td><td style='width:25%'>${formatDate(
          city.onwarddate,
          API_DATE_FORMAT,
        )}( Flexible by ${city.onwarddateFlexible} Days)</td></tr>`;
      });
    }
    // htmlContent += `<tr><td>No of Adults</td><td>${numberOfAdult}</td></tr><tr><td>No of Child</td><td>${numberOfChild}</td></tr><tr><td>No of Infant</td><td>${numberOfInfant}</td></tr><tr><td>Pref Class</td><td>${prefClass}</td></tr><tr><td>Pref Airline</td><td>${prefAirline}</td></tr><tr><td>Group Type</td><td>${groupTypeOption}</td></tr><tr><td>Remarks</td><td>${remarks}</td></tr></table>`;

    const res = await groupBookingRequest(travelType, htmlContent);
    if (res && res?.Root?.Status === 'OK') {
      setAlert({
        variant: 'success',
        title: 'Group Booking Request',
        description: res?.Root?.Message
          ? res?.Root?.Message
          : 'Request Accepted Successfully',
      });
    } else {
      setAlert({
        variant: 'error',
        title: 'Group Booking',
        description: res.Root?.Message
          ? res.Root?.Message
          : 'Failed to raise request please contact customer care',
      });
    }
    // const userResponse = await getUserDetails(getUserAgentId());
    // if (
    //   userResponse &&
    //   userResponse.ApiStatus &&
    //   userResponse.ApiStatus.Status === 'OK'
    // ) {
    //   const { User } = userResponse.ApiStatus.Result;
    //   if (!isEmpty(User)) {
    //     const { FirstName, LastName, ContactEmail } = User;
    //     const emailSubject = 'Group Booking Request';
    //     const fromEmail = ContactEmail;
    //     const fromName = `${FirstName} ${LastName}`;
    //     const toEmail = appConfig?.supportMail;
    //     const emailContent = htmlContent;

    //     const response = await sendVisaRequest(
    //       emailSubject,
    //       fromName,
    //       fromEmail,
    //       toEmail,
    //       emailContent,
    //     );
    //     if (response && response.Root && response.Root.Status === 'OK') {
    //       setAlert({
    //         title: 'Group Request',
    //         description: 'Request Submitted Successfully',
    //         variant: 'success',
    //       });
    //       setTimeout(() => {
    //         window.location.reload();
    //       }, 2000);
    //     } else {
    //       setAlert({
    //         title: 'Group Request',
    //         description: 'Failed to submit request',
    //         variant: 'error',
    //       });
    //     }
    //   }
    // }

    setIsLoading(false);
  };

  return (
    <section className="group-booking-request">
      {alert && (
        <AppAlert
          title={alert.title}
          description={alert.description}
          variant={alert.variant}
          showIcon={false}
          onHide={() => setAlert(undefined)}
        />
      )}
      <AppLoading isLoading={isLoading} />
      <div className="group-booking-request_container">
        <div>
          <div className="d-flex mb-3 gap-3">
            <AppRadioInput
              id="Domestic Travel"
              name="journeyType"
              labelText="Domestic Travel"
              value="Domestic Travel"
              radioClassName="mx-1"
              onChange={() => setTravelType('Domestic Travel')}
              checked={travelType === 'Domestic Travel'}
            />
            <AppRadioInput
              id="International Travel"
              name="journeyType"
              labelText="International Travel"
              value="International Travel"
              labelClassName="mx-2"
              radioClassName="mx-1"
              onChange={() => setTravelType('International Travel')}
              checked={travelType === 'International Travel'}
            />
          </div>
          <div className="d-flex gap-3 mb-3">
            <AppRadioInput
              id="OneWay"
              name="journeytype"
              labelText="One Way"
              value="OneWay"
              radioClassName="mx-1"
              onChange={() => setJourneyType('OneWay')}
              checked={journeyType === 'OneWay'}
            />
            <AppRadioInput
              id="RoundTrip"
              name="journeytype"
              labelText="Round Trip"
              value="RoundTrip"
              labelClassName="mx-2"
              radioClassName="mx-1"
              onChange={() => setJourneyType('RoundTrip')}
              checked={journeyType === 'RoundTrip'}
            />
          </div>
          <div>
            {journeyType !== 'MultiCity' ? (
              <Row className="spacing-16">
                <Col lg={6} md={6} sm={12} xs={12}>
                  <AppAsyncSelect
                    placeholder=""
                    name="origin"
                    components={{ Option: AirportOption }}
                    selectedValue={originAirportRef.current}
                    loadOptionsFn={loadAirportSuggestions}
                    onSelect={handleAirportSelect}
                    label={formattedMessage('depart_from')}
                    menuWidth="320px !important"
                  />
                </Col>
                <Col lg={6} md={6} sm={12} xs={12}>
                  <AppAsyncSelect
                    placeholder=""
                    name="destination"
                    components={{ Option: AirportOption }}
                    selectedValue={destinationAirportRef.current}
                    loadOptionsFn={loadAirportSuggestions}
                    onSelect={handleAirportSelect}
                    label={formattedMessage('going_to')}
                    menuWidth="320px !important"
                  />
                </Col>
                <Col lg={6} md={6} sm={12} xs={12}>
                  <AppDatePicker
                    customClassName="app-landing-datepicker"
                    label="Start Date"
                    labelClassName="landing-datepicker-label"
                    minDate={getNewDate(TODAY_DATE)}
                    monthsShown={2}
                    dateFormat="dd MMM yy"
                    selectedDate={fromDate}
                    onChange={(date) => setFromDate(date)}
                    showDay
                  />
                  <div className="my-2 fs-12 ms-1">
                    Flexible By
                    <select
                      onChange={(e) => setFromDateFlexible(e.target.value)}
                      value={fromDateFlexible}
                    >
                      <option>0</option>
                      <option>1</option>
                      <option>2</option>
                      <option>3</option>
                      <option>4</option>
                    </select>{' '}
                    Days
                  </div>
                </Col>
                <Col lg={6} md={6} sm={12} xs={12}>
                  <AppDatePicker
                    customClassName="app-landing-datepicker"
                    label="Return Date"
                    labelClassName="landing-datepicker-label"
                    minDate={getNewDate(TODAY_DATE)}
                    disabled={journeyType === 'OneWay'}
                    selectedDate={toDate}
                    monthsShown={2}
                    dateFormat="dd MMM yy"
                    onChange={(date) => setToDate(date)}
                  />
                  <div className="my-2 fs-12 ms-1">
                    Flexible By
                    <select
                      onChange={(e) => setToDateFlexible(e.target.value)}
                      value={toDateFlexible}
                    >
                      <option value="0">0</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                    </select>{' '}
                    Days
                  </div>
                </Col>
              </Row>
            ) : (
              <>
                {multiCitySearch.map((d, index) => (
                  <Row className="spacing-16 align-items-baseline" key={index}>
                    <Col lg={6} md={6} sm={12}>
                      <AppAsyncSelect
                        name="origin"
                        placeholder="From"
                        components={{ Option: AirportOption }}
                        selectedValue={d.selectedOrigin}
                        loadOptionsFn={loadAirportSuggestions}
                        onSelect={(airport, name) =>
                          handleMultiCityChange(airport, name, index)
                        }
                        isClearable={false}
                      />
                    </Col>
                    <Col lg={6} md={6} sm={12}>
                      <AppAsyncSelect
                        name="destination"
                        placeholder="To"
                        components={{ Option: AirportOption }}
                        selectedValue={d.selectedDestination}
                        loadOptionsFn={loadAirportSuggestions}
                        onSelect={(airport, name) =>
                          handleMultiCityChange(airport, name, index)
                        }
                        isClearable={false}
                      />
                    </Col>
                    <Col lg={6} md={6} sm={12}>
                      <AppDatePicker
                        className="fs-dep-date-input"
                        customClassName="app-date-picker"
                        placeholder="Departure Date"
                        minDate={getNewDate(TODAY_DATE)}
                        selectedDate={d.onwarddate}
                        onChange={(date) =>
                          handleMultiCityChange(date, 'onwarddate', index)
                        }
                      />
                      <div className="my-2 fs-12 ms-1">
                        Flexible By
                        <select
                          onChange={(e) =>
                            handleMultiCityChange(
                              e.target.value,
                              'onwarddateFlexible',
                              index,
                            )
                          }
                          value={d.onwarddateFlexible}
                        >
                          <option value="0">0</option>
                          <option value="1">1</option>
                          <option value="2">2</option>
                          <option value="3">3</option>
                          <option value="4">4</option>
                        </select>{' '}
                        Days
                      </div>
                    </Col>
                    {multiCitySearch.length > 1 && (
                      <Col lg={6} md={6} sm={12}>
                        <AppLink
                          linkText="Remove"
                          onClick={() => onRemoveMultiCityRow(index)}
                          variant="red"
                          className="fw-600"
                        />
                      </Col>
                    )}
                  </Row>
                ))}
                <AppButton
                  variant="outlined"
                  btnText="Add Flight"
                  className="mt-1"
                  onClick={onAddMultiCityRow}
                />
              </>
            )}
          </div>
          <Row className="spacing-16 my-2">
            <Col lg={6} md={6} sm={6} xs={12}>
              <AppSelect
                name="prefClass"
                placeholder=""
                label="Pref Class"
                options={PREF_CLASS_OPTIONS}
                onSelect={(d) => setPrefClass(d.value)}
                selectedValue={prefClass}
                isClearable={false}
              />
            </Col>
            <Col lg={6} md={6} sm={6} xs={12}>
              <AppSelect
                name="prefAirline"
                placeholder=""
                label="Pref Airline"
                options={PREF_AIRLINE_OPTIONS}
                onSelect={(d) => setPrefAirline(d.value)}
                selectedValue={prefAirline}
                isClearable={false}
              />
            </Col>
            <Col lg={6} md={6} sm={6} xs={12}>
              <AppNumberInput
                label="No of Adult(s)"
                placeholderText="(>12 Years)"
                value={numberOfAdult}
                onChange={(d) => setNumberOfAdult(d)}
                required
              />
            </Col>
            <Col lg={6} md={6} sm={6} xs={12}>
              <AppNumberInput
                label="No of Child(s)"
                placeholderText="(2 to 12 Year)"
                value={numberOfChild}
                onChange={(d) => setNumberOfChild(d)}
                required
              />
            </Col>
            <Col lg={6} md={6} sm={6} xs={12}>
              <AppNumberInput
                label="No of Infant(s)"
                placeholderText="(7 Days to 2 Years)"
                value={numberOfInfant}
                onChange={(d) => setNumberOfInfant(d)}
                required
              />
            </Col>
            <Col lg={6} md={6} sm={6} xs={12}>
              <AppSelect
                name="GroupType"
                placeholder=""
                label="GroupType"
                options={GROUP_TYPE_OPTIONS}
                onSelect={(d) => setGroupTypeOption(d.value)}
                selectedValue={groupTypeOption}
                isClearable={false}
                required
              />
            </Col>
            <Col lg={6} md={6} sm={6} xs={12}>
              <AppTextInput
                label="Remarks"
                placeholderText=""
                value={remarks}
                onChange={(e) => setRemarks(e.target.value)}
                required
              />
            </Col>
          </Row>
          <div className="d-flex justify-content-center">
            <AppButton
              btnText="Raise Request"
              onClick={handleGroupBookingRequest}
            />
          </div>
        </div>
      </div>
    </section>
  );
}

GroupBookingRequest.propTypes = {
  agent: PropTypes.object.isRequired,
};

export default GroupBookingRequest;
